export const THEME = {
  primary: 'var(--theme-primary)',
  primaryHover: 'var(--theme-primary-hover)',
  primaryLight: 'var(--theme-primary-light)',
  onPrimary: 'var(--theme-on-primary)',
  alpha: (opacity) => `rgba(var(--theme-primary-rgb), ${opacity})`,
};